import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

export function SetMetaTags({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  ogType,
  robots,
  hreflangs,
}) {
  const location = useLocation();

  const siteUrl = (
    process.env.REACT_APP_SITE_URL || window.location.origin
  ).replace(/\/+$/, "");

  // useLocation().pathname is always in sync with React Router navigation
  const currentPath = location.pathname;
  const currentUrl = siteUrl + location.pathname;
 
  const metaTitle = title || "Weyfarin";
  const metaDescription = description || "";
  const metaKeywords = keywords || "";
  const finalCanonicalUrl = canonicalUrl || siteUrl + currentPath;
 
  const finalOgTitle = ogTitle || title || "Weyfarin";
  const finalOgDescription = ogDescription || description || "";
  const finalOgUrl = ogUrl || siteUrl + currentPath;
  const finalOgType = ogType || "website";
  const finalOgImage = ogImage || `${siteUrl}/images/w_logo.png`;
 
  const finalRobots = robots || "index, follow";
 
  useEffect(() => {
    const updateMeta = (property, content) => {
      let tag = document.querySelector(
        `meta[property="${property}"]`
      );

      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }

      tag.setAttribute("content", content);
    };

    // Update canonical <link> tag
    let canonicalTag = document.querySelector('link[rel="canonical"]');
    if (!canonicalTag) {
      canonicalTag = document.createElement("link");
      canonicalTag.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.setAttribute("href", finalCanonicalUrl);

    // Update OG meta tags
    updateMeta("og:title", finalOgTitle);
    updateMeta("og:description", finalOgDescription);
    updateMeta("og:url", finalOgUrl);
    updateMeta("og:type", finalOgType);
    updateMeta("og:image", finalOgImage);
  }, [
    finalCanonicalUrl,
    finalOgTitle,
    finalOgDescription,
    finalOgUrl,
    finalOgType,
    finalOgImage,
  ]);
 
  return (
    <Helmet>
      <title>{metaTitle}</title>
 
      <meta
        name="description"
        content={metaDescription}
      />
 
      <meta
        name="keywords"
        content={metaKeywords}
      />
 
      <link
        rel="canonical"
        href={finalCanonicalUrl}
      />
 
      <meta
        name="robots"
        content={finalRobots}
      />
    </Helmet>
  );
}